<div class="payment-history-container" #paymentHistoryContainer>
  @if (paymentHistoryLoading$ | async) {
    <ds-localized-spinner
      [dataLoading]="paymentHistoryLoading$ | async"
      [loadingMessage]="'Looking for payment history...'"
    >
    </ds-localized-spinner>
  } @else {
    <form [formGroup]="paymentHistoryForm">
      <div class="row">
        <div class="column twelve md-six">
          <span class="dropdown-label font-size-1 font-weight-semibold">
            {{ paymentHistoryCopy.billingHistorySortFormLabel }}
          </span>
          <ds-form-control-container
            [control]="paymentHistoryForm.controls['monthRange']"
            class="pading-sort pad-bottom-16"
          >
            <select class="icon fill" formControlName="monthRange">
              @for (range of monthRanges; track range; let index = $index) {
                <option [value]="index">
                  {{ range.text }}
                </option>
              }
            </select>
            <span class="icon-chevron-down"></span>
          </ds-form-control-container>
        </div>
        <div class="column twelve md-six">
          <span class="dropdown-label font-size-1 font-weight-semibold">
            {{ paymentHistoryCopy.billingHistoryAccountFormLabel }}
          </span>
          <ds-form-control-container
            [control]="paymentHistoryForm.controls['billAccount']"
            class="pading-account pad-bottom-16"
          >
            <select class="icon fill" formControlName="billAccount">
              @for (billAccOption of riskDescriptionOption; track billAccOption) {
                <option [value]="billAccOption">
                  {{ billAccOption }}
                </option>
              }
            </select>
            <span class="icon-chevron-down"></span>
          </ds-form-control-container>
        </div>
      </div>
    </form>
    <div class="row payment-tiles">
      @if (paymentHistoryListForView.length > 0) {
        @for (payments of paymentHistoryListForView; track payments) {
          <div class="row column twelve payment-tile-container">
            <div class="column six">
              <div
                class="payment-status"
                [ngClass]="{ 'scheduled-status': payments.paymentStatus === 'Scheduled payment' }"
              >
                {{ payments.paymentStatus }}
              </div>
              <div class="payment-basic-text">{{ payments.paymentAccount }}</div>
            </div>
            <div class="column six flex-end-section">
              <div class="payment-amount">{{ payments.paymentAmount }}</div>
              <div class="payment-basic-text">
                {{ payments.paymentDate | date: 'MMM d, yyyy' }}
              </div>
            </div>
            <div class="column twelve payment-basic-text">{{ payments.risk }}</div>
            @if (payments.paymentStatus === 'Scheduled payment') {
              <div class="column twelve btn-container flex">
                <div class="column six">
                  <button
                    ds-button
                    class="-outline edit-btn"
                    (click)="onEditPayment(payments.paymentId)"
                    [attr.aria-label]="'Edit Payment'"
                  >
                    {{ editBtnCopy }}
                  </button>
                </div>
                <div class="column six flex-end-section">
                  <button
                    ds-button
                    class="link delete-btn"
                    (click)="onDeletePayment(payments)"
                    [attr.aria-label]="'Delete Payment'"
                  >
                    <span class="icon-trash delete-icon"></span> {{ deleteBtnCopy }}
                  </button>
                </div>
              </div>
            }
          </div>
        }

        @if (paymentHistoryListForView?.length > 0) {
          <div class="data-info">
            <span class="font-size-0-75 font-weight-normal">
              {{ paymentHistoryCopy.billingHistoryShowingLabel }}
              {{ paymentHistoryListForView?.length }} of {{ totalPossiblePayments }}
              {{ paymentHistoryCopy.billingHistoryPayments }}
            </span>
          </div>
        }

        @if (paymentHistoryListForView?.length < totalPossiblePayments) {
          <div class="items-center text-center more-action">
            <span class="font-size-1 font-weight-semibold" (click)="loadMore()">
              {{ paymentHistoryCopy.paymentHistoryShowMore }}
              <img src="/assets/images/chevron-down-thick.svg" />
            </span>
          </div>
        }
      } @else {
        @if ((hasError$ | async) === false) {
          <p dsContent [contentPath]="'billing.noPaymentHistory'"></p>
        } @else {
          <p dsContent [contentPath]="'billing.noPaymentHistoryApiError'"></p>
        }
      }
    </div>
  }
</div>

<ds-alert-modal
  [config]="deletePendingPaymentModalConfig"
  (primaryEvent)="removePendingPayment()"
  (tertiaryEvent)="cancel()"
>
  @if ((dataLoading$ | async) && !actionInFlight) {
    <ds-localized-spinner
      class="block pad-bottom-20"
      [dataLoading]="dataLoading$ | async"
      [loadingMessage]="loadingMsgText"
    ></ds-localized-spinner>
  }
</ds-alert-modal>
